import React from "react";
import { Box, Typography, FormControlLabel, Checkbox, Divider } from "@mui/material";

const AgreementBox = ({ checked, onChange, label, disabled, hasError }) => (
  <Box
    sx={{
      p: { xs: 2, sm: 2.5 },
      border: hasError
        ? "2px solid #ef4444"
        : checked
        ? "2px solid #163666"
        : "1px solid #dfdfdf",
      borderRadius: 2,
      backgroundColor: checked ? "#eff6ff" : "#fafafa",
      transition: "all 0.15s ease",
      mb: 2,
      "&:last-child": { mb: 0 },
    }}
  >
    <FormControlLabel
      control={
        <Checkbox
          checked={checked}
          onChange={onChange}
          disabled={disabled}
          sx={{
            color: "#163666",
            "&.Mui-checked": { color: "#163666" },
            alignSelf: "flex-start",
            mt: 0.25,
            p: 0.75,
          }}
        />
      }
      label={
        <Typography variant="body2" sx={{ lineHeight: 1.75, color: "#374151", fontSize: "0.875rem" }}>
          {label}
        </Typography>
      }
      sx={{ alignItems: "flex-start", mr: 0 }}
    />
  </Box>
);

export const DeclarationSection = ({
  formData,
  handleInputChange,
  isEditable,
  validationErrors,
  t,
}) => (
  <>
    <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, mb: 3 }}>
      <Box sx={{ width: 3, height: 22, backgroundColor: "#163666", borderRadius: 2, flexShrink: 0 }} />
      <Typography variant="h6" sx={{ fontWeight: 700, color: "#1a1a2e" }}>
        {t.declaration}
      </Typography>
      <Typography variant="body2" sx={{ color: "#ef4444", fontWeight: 600 }}>*</Typography>
    </Box>

    <Box sx={{ mb: 4 }}>
      <AgreementBox
        checked={formData.consentDeclaration}
        onChange={(e) => handleInputChange("consentDeclaration", e.target.checked)}
        label={t.consentDeclaration}
        disabled={!isEditable}
        hasError={!!validationErrors.consentDeclaration}
      />
      <AgreementBox
        checked={formData.dataUsageAgreement}
        onChange={(e) => handleInputChange("dataUsageAgreement", e.target.checked)}
        label={t.dataUsageAgreement}
        disabled={!isEditable}
        hasError={false}
      />
    </Box>

    <Divider sx={{ borderColor: "#dfdfdf" }} />
  </>
);
